/**
 * NodeService - Node/Connection関連の操作を管理
 */

import type { AppState, Node, Connection, GraphOperation } from '../types'

export class NodeService {
  /**
   * ノードを作成
   */
  static createNode(
    setId: string,
    imageId: string,
    label?: string,
    position?: 'first' | 'last' | 'middle'
  ): Node {
    return {
      id: crypto.randomUUID(),
      setId,
      imageId,
      label,
      position
    }
  }

  /**
   * 2つのノード間に接続を作成
   */
  static createConnection(
    fromNodeId: string,
    toNodeId: string,
    type?: 'transition' | 'branch' | 'merge',
    bidirectional = false
  ): Connection {
    return {
      id: crypto.randomUUID(),
      fromNodeId,
      toNodeId,
      type,
      bidirectional
    }
  }

  /**
   * 2つのセット間を接続（簡易メソッド）
   */
  static *connectSets(
    state: AppState,
    fromSetId: string,
    fromImageId: string,
    toSetId: string,
    toImageId: string,
    bidirectional = false
  ): Generator<GraphOperation> {
    // ノードが存在しなければ作成
    let fromNode = Object.values(state.nodes).find(
      n => n.setId === fromSetId && n.imageId === fromImageId
    )
    if (!fromNode) {
      fromNode = NodeService.createNode(fromSetId, fromImageId, 'connection')
      yield { type: 'ADD_NODE', payload: fromNode }
    }
    
    let toNode = Object.values(state.nodes).find(
      n => n.setId === toSetId && n.imageId === toImageId
    )
    if (!toNode) {
      toNode = NodeService.createNode(toSetId, toImageId, 'connection')
      yield { type: 'ADD_NODE', payload: toNode }
    }
    
    // 接続を作成
    const connection = NodeService.createConnection(fromNode.id, toNode.id, 'transition', bidirectional)
    yield { type: 'ADD_CONNECTION', payload: connection }
  }
}